export default {
    methods: {
        formatDate (date) {
            return moment(date).format('DD/MM/YYYY')
        },

        formatDateHour (date) {
            return `${moment(date).format('DD/MM/YYYY')} à ${moment(date).format('HH:mm')}`
        }
    }
}



// WEBPACK FOOTER //
// ./client/mixins/dateFormatting.js